import React from 'react';
import ReactDOM from 'react-dom';
import {Link} from "react-router-dom";
import {DownloadReportModal, Modal} from "react-spaceship-web";
import ShipmentProductAudit from "./ShipmentProductAudit";
import {history} from "./AppProvider";

function SetupProductQuantityAndUnitSelect(props) {
	return (
		<div className="ui right action left input"
		     style={{width: '100%'}}
		     ref={(ref) => {
			     let $parent = window.$(props.$parent);

			     let $user_input_quantity = $parent.find('input[name="user_input_quantity"]');
			     $user_input_quantity.on('keyup', (e) => {
				     let user_input_quantity = window.$(e.target).cleanNumber();
				     let qty = user_input_quantity * parseFloat($parent.find('input[name="' + props['input_name_ratio'] + '"]').val());
				     $parent.find('input[name="' + props['input_name_quantity'] + '"]').val(qty);
			     }).on('focus', function () {
				     window.$(this).select();
			     });

			     // create dropdown select unit name
			     window.$.each(props['product']['sell_price'], (i2, value2) => {
				     value2.index = i2;
				     $parent.find('.Item_selectUnitName .menu').append(window.Mustache.render('<div data-value="{{index}}" data-index="{{index}}" data-ratio="{{ratio}}" class="item">{{unit_name}}</div>', value2));
			     });
			     // set unit name
			     $parent.find('.Item_selectUnitName').dropdown({
				     onChange: (value2, text2, $choice) => {
					     let data = $choice.data();
					     $parent.find('input[name="' + props['input_name_ratio'] + '"]').val(parseFloat(data['ratio']));
					     $user_input_quantity.trigger('keyup');
				     }
			     });

			     $parent.find('.Item_selectUnitName').dropdown('set selected', '0');
		     }}>
			<input type="text"
			       name="user_input_quantity"
			       placeholder="จำนวน"
			       defaultValue="0"
			       readOnly={props.readonly}
			/>
			<div className="ui basic floating dropdown button Item_selectUnitName">
				<div className="text">-</div>
				<div className="menu"/>
			</div>
			<input type="hidden" name={props.input_name_ratio}/>
			<input type="hidden" name={props.input_name_quantity}/>
		</div>
	)
}

export default class ProductStock extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	route() {
		window.Route.on({
			'/v2/product-stock': () => {
				let qs = window.Global.getAllQueryStrings();
				if (!qs.stock_id) {
					qs.stock_id = '';
				}
				if (!qs.search_query) {
					qs.search_query = '';
				}
				if (!qs.end_date) {
					qs.end_date = '';
				}
				qs.request_data_stock_alert = true;

				this.setState({
					mode: 'list',
					is_loading: true,
					stocks: [],
					products: [],
					qs: qs
				}, () => {
					this.fetch();
				})
			},
		}).match();
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.props.location.pathname !== prevProps.location.pathname) {
			this.route();
		} else if (this.props.location.search !== prevProps.location.search) {
			this.route();
		}
	}

	componentDidMount() {
		// if (this.state.mode === 'view') {
		// 	this.view();
		// }
		// if (this.state.mode === 'list') {
		// 	this.fetch();
		// }
		// if (this.state.mode === 'edit') {
		// 	this.edit();
		// }
		// if (this.state.mode === 'create') {
		// 	this.create();
		// }
		this.route();
	}

	fetch() {
		window.Global.ajax({
			method: 'GET',
			url: process.env.REACT_APP_DOMAIN + '/api/stock',
			data: {all: true, type: 'all'},
			done: (response) => {
				if (!response.success) {
					return false;
				}

				// this.$parent.find('#create-stock-alert-button').off('click').on('click', function () {
				// 	// CheckStock.manageStockAlert();
				// });

				window.Global.ajax({
					method: 'GET',
					url: process.env.REACT_APP_DOMAIN + '/api/product/quantity_in_stock',
					data: {
						...this.state.qs,
						limit: 50,
					},
					done: (response2) => {
						if (!response2.success) {
							return false;
						}

						this.setState({
							is_loading: false,
							stocks: response.stock,
							company_info: response2.company_info,
							products: response2.product,
							is_current: response2.is_current,
							stock: response2.stock || false,
							has_products: response2.has_products || [],
						}, () => {
							this.$parent.find('.table').tablePagination({
								disableContent: true,
								data: response2.product,
								count: response2.count,
								maxSize: 50,
								onClickPagination: (p) => {
									let qs = {...this.state.qs};
									qs.page = p;
									this.props.history.push(
										window.Global.getQueryStringLinkFromObject(qs)
									);
								}
							});
						});
					}
				});
			}
		});
	}

	manageDisplayRatio(product) {
		this.setState({
			modal: (
				<div>
					<Modal
						onShowToSetupForm={($modal) => {
							$modal.find('form').form2('setup', {});
							$modal.find('input[name="stock_id"]').explorer({
								url: process.env.REACT_APP_DOMAIN + '/api/stock',
								additionalData: {},
								key: 'stock',
								template: {
									list: function (stock) {
										return window.Handlebars.compile('<div class="item">\n\t<div class="flex row">\n\t\t<div>\n\t\t\t<b>{{name}}</b>\n\t\t</div>\n\t</div>\n</div>')(stock);
									},
									selected: {
										display_template: '{{name}}',
										value: 'id',
										placeholder: 'ระบุคลังสินค้า'
									}
								}
							});
							if (this.state.stock) {
								$modal.find('input[name="stock_id"]').explorer(
									'set value',
									this.state.stock
								);
							}
							$modal.find('form').form2('submit', {
								method: 'PUT',
								url: process.env.REACT_APP_DOMAIN + '/api/product/stock/display-by-ratio',
								loadingButton: $modal.find('.button'),
								onSuccess: () => {
									window.Global.messageTop({
										type: 'positive',
										message: 'บันทึกข้อมูลเรียบร้อย'
									});
									$modal.modal('hide');
									this.fetch();
								}
							});
						}}
						onHide={() => {
							this.setState({
								modal: null,
							});
						}}
					>
						<div className="header">แสดงหน่วยนับอื่น</div>
						<div className="content">
							<form className="ui form" autoComplete="off">
								<div className="field">
									<label>คลังสินค้า</label>
									<input type="hidden"
									       name="stock_id"
									       value=""
									/>
								</div>
								<div className="field">
									<label>เลือกหน่วยนับของสินค้า {product.product.name}</label>
									<select name="check_stock_display_ratio"
									        className="ui dropdown"
									        data-form2_setup="">
										{
											product['product'].sell_price.map((sell_price, i) => {
													return (
														<option key={i}
														        value={sell_price.ratio}>{sell_price.unit_name}</option>
													)

												}
											)
										}
									</select>
									<input type="hidden"
									       name="product_id"
									       value={product.product.id}
									/>
								</div>
								<div className="ui error message"/>
							</form>
						</div>
						<div className="actions">
							<div className="flex row">
								<div className="right floated">
									<div className="ui deny button">ยกเลิก</div>
									<div
										className="ui approve green right button">บันทึก
									</div>
								</div>
							</div>
						</div>
					</Modal>
				</div>
			)
		})
	}

	manageStockAlert(product, stock_alert) {
		ReactDOM.render(
			<div>
				<Modal
					onShowToSetupForm={($modal) => {
						$modal.find('form').form2('setup', {
							'is_minimum_onChange': (value) => {
								if (value) {
									$modal.find('#min input[name="user_input_quantity"]')
										.removeAttr('readonly')
										.focus();
								} else {
									$modal.find('#min input[name="user_input_quantity"]')
										.val(0)
										.attr('readonly', 'readonly');
								}
							},
							'is_maximum_onChange': (value) => {
								if (value) {
									$modal.find('#max input[name="user_input_quantity"]')
										.removeAttr('readonly')
										.focus();
								} else {
									$modal.find('#max input[name="user_input_quantity"]')
										.val(0)
										.attr('readonly', 'readonly');
								}
							}
						});

						$modal.find('input[name="stock_id"]').explorer({
							url: process.env.REACT_APP_DOMAIN + '/api/stock',
							additionalData: {
								limit: 5,
								page: 1
							},
							key: 'stock',
							template: {
								list: '<a class="item flex row">{{name}}</a>',
								selected: {
									text: 'name',
									value: 'id',
									placeholder: 'เลือกคลังสินค้า'
								}
							}
						});
						$modal.find('input[name="product_id"]').explorer({
							url: process.env.REACT_APP_DOMAIN + '/api/product',
							additionalData: function () {
								return {
									page: 1,
									limit: 5,
									is_not_count_stock: 0,
									is_monthly_payment: 0
								};
							},
							key: 'product',
							template: {
								list: '<a class="item flex row">{{name}}</a>',
								selected: {
									text: 'name',
									value: 'id',
									placeholder: 'เลือกสินค้า'
								}
							},
							onSelected: (product) => {
								ReactDOM.render(
									<SetupProductQuantityAndUnitSelect
										$parent={$modal.find('#min')}
										product={product}
										input_name_quantity={'minimum'}
										input_name_ratio={'minimum_ratio'}
										readonly={!stock_alert || !stock_alert.is_minimum}
									/>,
									$modal.find('#min').get(0)
								);
								ReactDOM.render(
									<SetupProductQuantityAndUnitSelect
										$parent={$modal.find('#max')}
										product={product}
										input_name_quantity={'maximum'}
										input_name_ratio={'maximum_ratio'}
										readonly={!stock_alert || !stock_alert.is_maximum}
									/>,
									$modal.find('#max').get(0)
								);
							},
							onUnSelected: function () {
								$modal.find('#min,#max').empty();
							}
						});

						if (this.state.stock) {
							$modal.find('input[name="stock_id"]').explorer('set value', this.state.stock);
						}
						if (product) {
							$modal.find('input[name="product_id"]').explorer('set value', product);

							if (stock_alert) {
								setTimeout(() => {
									window.$.each(product.sell_price, (i, sell_price) => {
										if (sell_price.ratio === parseFloat(stock_alert.minimum_ratio)) {
											$modal.find('#min input[name="user_input_quantity"]').val(
												parseFloat(stock_alert.minimum) / parseFloat(stock_alert.minimum_ratio)
											);
											$modal.find('#min .Item_selectUnitName').dropdown('set selected', i + '');
										}
										if (sell_price.ratio === parseFloat(stock_alert.maximum_ratio)) {
											$modal.find('#max input[name="user_input_quantity"]').val(
												parseFloat(stock_alert.maximum) / parseFloat(stock_alert.maximum_ratio)
											);
											$modal.find('#max .Item_selectUnitName').dropdown('set selected', i + '');
										}
									});
								})
							}
						}

						$modal.find('form').form2('submit', {
							method: 'POST',
							url: process.env.REACT_APP_DOMAIN + '/api/stock/alert',
							loadingButton: $modal.find('.button'),
							//submitButton: $modal.find('.button.approve'),
							onSuccess: () => {
								window.Global.messageTop({
									type: 'positive',
									message: 'บันทึกข้อมูลเรียบร้อย'
								});
								$modal.modal('hide');
								this.fetch();
							}
						});
					}}
					onHide={() => {
						ReactDOM.unmountComponentAtNode(
							document.getElementById('modal')
						);
					}}
				>
					<div className="header">แจ้งเตือนจำนวนสินค้า</div>
					<div className="content">
						<form className="ui form" autoComplete="off">
							<div className="field">
								<label>คลังสินค้า</label>
								<input type="text" name="stock_id"/>
							</div>
							<div className="field">
								<label>สินค้า</label>
								<input type="text" name="product_id"/>
							</div>
							<div className="field">
								<div className="flex row" style={{margin: '0 0 .5rem 0'}}>
									<div className="ui checkbox" data-form2_setup="">
										<input id="is_minimum"
										       type="checkbox"
										       tabIndex="-1"
										       name="is_minimum"
										       defaultChecked={stock_alert && stock_alert.is_minimum}
										/>
									</div>
									<label htmlFor="is_minimum">แจ้งเตือนเมื่อ <u>ต่ำกว่า</u></label>
								</div>
								<div id="min"/>
							</div>
							<div className="field">
								<div className="flex row" style={{margin: '0 0 .5rem 0'}}>
									<div className="ui checkbox" data-form2_setup="">
										<input id="is_maximum"
										       type="checkbox"
										       tabIndex="-1"
										       name="is_maximum"
										       defaultChecked={stock_alert && stock_alert.is_maximum}
										/>
									</div>
									<label htmlFor="is_maximum">แจ้งเตือนเมื่อ <u>สูงกว่า</u></label>
								</div>
								<div id="max"/>
							</div>
							<div className="ui error message"/>
						</form>
					</div>
					<div className="actions">
						<div className="flex row">
							<div className="right floated">
								<div className="ui deny button">ยกเลิก</div>
								<div
									className="ui approve green right button">บันทึก
								</div>
							</div>
						</div>
					</div>
				</Modal>
			</div>,
			window.$('#modal').get(0)
		);
	}

	voidStockAlert(stock_alert_id) {
		window.Global.confirm({
			title: 'ยกเลิกแจ้งเตือน',
			content: '<form>โปรดยืนยันยกเลิกการแจ้งเตือนสินค้า</form>',
			cancel_text: 'ยกเลิก',
			approve_text: 'ยืนยัน',
			onShow: ($modal) => {
				let $form = $modal.find('form');
				$form.form2('submit', {
					method: 'DELETE',
					url: process.env.REACT_APP_DOMAIN + '/api/stock/alert',
					beforeSent: function (data) {
						data['stock_alert_id'] = stock_alert_id;
						return data;
					},
					onSuccess: () => {
						window.Global.messageTop({
							type: 'positive',
							message: 'บันทึกข้อมูลเรียบร้อย'
						});
						$modal.modal('hide');
						this.fetch();
					}
				});
			},
			onApprove: function ($modal) {
				$modal.find('form').trigger('submit');
				return false;
			}
		});
	}

	downloadReport() {
		ReactDOM.render(
			<div>
				<Modal
					onShowToSetupForm={($modal) => {
						$modal.find('form').form2('setup');
						$modal.find('.approve').off('click').on('click', (e) => {
							e.preventDefault();

							let data = window.Global.getAllQueryStrings();
							data.is_download_excel = 1;
							data = Object.assign(data, $modal.find('form').serializeObject());

							window.Global.reactToDom(
								window.$('body'),
								<DownloadReportModal
									url={process.env.REACT_APP_DOMAIN + '/api/product/quantity_in_stock'}
									data={data}/>
							);

							$modal.find('.deny').trigger('click');

							return false;
						});

						// $modal.find('form').form2('submit', {
						// 	method: 'POST',
						// 	url: process.env.REACT_APP_DOMAIN + '/api/stock/alert',
						// 	loadingButton: $modal.find('.button'),
						// 	//submitButton: $modal.find('.button.approve'),
						// 	onSuccess: () => {
						// 		window.Global.messageTop({
						// 			type: 'positive',
						// 			message: 'บันทึกข้อมูลเรียบร้อย'
						// 		});
						// 		$modal.modal('hide');
						// 		this.fetch();
						// 	}
						// });
					}}
					onHide={() => {
						ReactDOM.unmountComponentAtNode(
							document.getElementById('modal')
						);
					}}
				>
					<div className="header">ดาวโหลดรายงาน</div>
					<div className="content">
						<form className="ui form" autoComplete="off">
							<div className="field">
								<div className="flex row" style={{margin: '0 0 .5rem 0'}}>
									<div className="ui checkbox" data-form2_setup="">
										<input id="is_show_zero"
										       type="checkbox"
										       tabIndex="-1"
										       name="is_show_zero"
										       defaultChecked={false}
										/>
									</div>
									<label htmlFor="is_show_zero">แสดงรายการสินค้าที่มี <u>ยอดคงเหลือเป็นศูนย์</u></label>
								</div>
								<div className="flex row" style={{margin: '0 0 .5rem 0'}}>
									<div className="ui checkbox" data-form2_setup="">
										<input id="is_show_negative"
										       type="checkbox"
										       tabIndex="-1"
										       name="is_show_negative"
										       defaultChecked={true}
										/>
									</div>
									<label htmlFor="is_show_negative">แสดงรายการสินค้าที่มี <u>ยอดคงเหลือติดลบ</u></label>
								</div>
								<div id="min"/>
							</div>
							<div className="ui error message"/>
						</form>
					</div>
					<div className="actions">
						<div className="flex row">
							<div className="right floated">
								<div className="ui deny button">ยกเลิก</div>
								<div
									className="ui approve green right button">ดาวโหลดรายงาน
								</div>
							</div>
						</div>
					</div>
				</Modal>
			</div>,
			window.$('#modal').get(0)
		);
	}

	renderList() {
		return (
			<div ref={(ref) => {
				if (!ref) return;
				this.$parent = window.$(ref);
			}}
				// key={'ddd' + window.Global.getRandomInt(1, 99999999)}
				  className="main ui container">
				{this.state.modal}
				<div id="modal"/>
				<div id="HeaderTop_root" className="flex row wrap" style={{marginBottom: '1rem'}}>
					<div className="flex row middle-xs center-xs">
						<div className="ui huge breadcrumb" style={{margin: '0 1em 0 0'}}>
							<Link className="active section" to="/v2/product-stock">ตรวจสอบยอดคงเหลือ</Link>
							<span className="divider" style={{margin: '0 0.7rem'}}>:</span>
							<span className="active section">
								{this.state.stock ? this.state.stock.name : 'ทุกคลัง'}
							</span>
						</div>
						<span id="count-stock-alert"/>
					</div>
					<div className="right floated">
						{/*<Link className="ui positive button"*/}
						{/*      to={"/v2/products/new"}>เพิ่มสินค้าใหม่</Link>*/}
					</div>
				</div>
				<div id="Search_root"
				     className="box"
				     style={{display: 'none', marginTop: '1rem'}}
				     ref={(ref) => {
					     let $search = window.$(ref);
					     $search.find('input[name="stock_id"]').val(this.state.qs.stock_id);
					     window.Search.init({
						     $node: $search,
						     onSubmit: (data) => {
							     this.props.history.push(window.Global.getQueryStringLinkFromObject(data));
							     return false;
						     }
					     });
					     $search.find('#download-report-button').off('click').on('click', () => {
						     this.downloadReport();
					     });

					     let $product_ids = $search.find('input[name="product_ids[]"]').explorer({
						     url: process.env.REACT_APP_DOMAIN + '/api/product',
						     additionalData: () => {
							     return {
								     page: 1,
								     limit: 30,
								     is_not_count_stock: 0,
								     exclude_product_id: $product_ids.explorer('get value')
							     }
						     },
						     key: 'product',
						     multiple: true,
						     template: {
							     list: (value) => {
								     let search = $product_ids.find('input[name="search"]').val();
								     return window.GlobalTemplate.getProductSearchList(search, value);
							     },
							     selected: {
								     display_template: '<span>{{name}} <a href="/v2/products/{{id}}" target="_blank"><i class="icon linkify"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tstyle="font-size: 0.8rem;margin: 0;color: #646464;"></i></a></span>',
								     value: 'id',
								     placeholder: 'ไม่กำหนด'
							     }
						     },
						     onSelected: () => {
							     let data = $search.find('form').serializeObject()
							     history.push(window.Global.getQueryStringLinkFromObject(data))
						     },
						     onUnSelected: () => {
							     let data = $search.find('form').serializeObject()
							     history.push(window.Global.getQueryStringLinkFromObject(data))
						     }
					     });

					     this.state.has_products.map((v) => {
						     $product_ids.explorer('set selected', v);
							  return true
					     })

					     // if (this.state.products
					     // 	&& this.state.products.length >= 1
					     // 	&& this.state.qs.product_ids
					     // ) {
					     // 	let _product_ids = []
					     // 	let __product_ids = this.state.qs.product_ids.split(',')
					     // 	__product_ids.map((v) => {
					     // 		_product_ids.push(parseInt(v))
					     // 	})
					     //
					     // 	for (const productsKey in this.state.products) {
					     // 		if (_product_ids.indexOf(this.state.products[productsKey]['product']['id']) !== -1) {
					     // 			$product_ids.explorer('set selected', this.state.products[productsKey]['product']);
					     // 		}
					     // 	}
					     // }
				     }}
				>
					<form className="ui form">
						<div className="flex row wrap padded five column computer">
							<div className="column field">
								<label htmlFor="">ค้นหาสินค้า (เลือกหลายสินค้าได้) <span
									className={'ui label green mini'}>ใหม่</span></label>
								<input type="text"
								       name="product_ids[]"
								       placeholder=""
								       autoComplete="off"
								/>
							</div>
							<div className="column field">
								<label htmlFor="">ค้นหาสินค้า</label>
								<input type="text"
								       name="search_query"
								       placeholder="ชื่อสินค้า/รหัส"
								       autoComplete="off"
								/>
								<input type="hidden" name="stock_id"/>
							</div>
							<div className="column field">
								<label>ณ วันที่</label>
								<div data-form_calendar="date"
								     data-input_name="end_date"
								     data-placeholder="ณ วันที่"
								     data-locale="th"
								     data-initialdate="now"
								/>
							</div>
							<div className="column fluid field right floated">
								<label htmlFor="">&nbsp;</label>
								<div className="flex row wrap">
									<button id="download-report-button" className="ui button basic" type="button">
										รายงานยอดคงเหลือ
									</button>
									<button className="ui button basic"
									        type="button"
									        onClick={() => {
										        this.manageStockAlert(false, false);
									        }}>
										แจ้งเตือน
									</button>
									<button className="ui button primary" type="submit">ค้นหา</button>
								</div>
							</div>
						</div>
						{
							!this.state.is_current
								?
								<div style={{paddingBottom: '1rem'}}>
									<span style={{color: 'green'}}
									      data-tooltip="หากเลือกดูข้อมูลวันย้อนหลัง และมีการเปลี่ยนแปลงเอกสารต่างๆ ซึ่งจะส่งผลกับยอดคงเหลือ ณ วันที่ที่ระบุ ยอดสินค้าคงเหลือจะอัพเดทล่าสุดทุกๆ 6 ชม."
									      data-position="top left center bottom right"
									      data-inverted="">
										<i className="icon info circle"/> ข้อมูลอัพเดทล่าสุดเมื่อ <b>{window.Global.getDateThai(this.state.company_info.chart_product_cost_calculate_last_date, {is_show_time: 1})} ณ.</b>
									</span>
								</div>
								: null
						}
					</form>
				</div>
				<div className="ui menu flex row wrap">
					<Link id="all-stock"
					      className={"item" + (!this.state.qs.stock_id ? " active " : "")}
					      to={window.Global.getQueryStringLinkFromObject({
						      ...this.state.qs,
						      stock_id: ''
					      })}>ทุกคลัง</Link>
					{
						this.state.stocks.map((stock, i) => {
							return (
								<Link className={"item" + (this.state.qs.stock_id === stock.id + '' ? " active " : "")}
								      key={i}
								      to={window.Global.getQueryStringLinkFromObject({
									      ...this.state.qs,
									      stock_id: stock.id
								      })}>
									{stock.name}
								</Link>
							)
						})
					}
				</div>
				<div className="flex row center-xs" style={{paddingBottom: '1rem'}}>
					<div className="ui buttons">
						<Link to={window.Global.getQueryStringLinkFromObject({
							...this.state.qs,
							is_only_stock_alert: ''
						})}
						      className={"ui button" + (!this.state.qs.is_only_stock_alert ? " green " : "")}>จำนวนคงเหลือ</Link>
						<Link to={window.Global.getQueryStringLinkFromObject({
							...this.state.qs,
							is_only_stock_alert: 1
						})}
						      className={"ui button" + (this.state.qs.is_only_stock_alert ? " green " : "")}>รายการแจ้งเตือน</Link>
					</div>
				</div>
				<div className="flex row wrap">
					<div className="ui basic table can click Table_root" style={{marginTop: 0}}>
						<div className="thead">
							<div className="tr">
								<div className="th col-lg-4">สินค้า</div>
								<div className="th col-lg-2">มีอยู่ในคลัง</div>
								<div className="th col-lg-2">กำลังสั่งซื้อ</div>
								<div className="th col-lg-2">พร้อมใช้งาน</div>
								<div className="th col-lg-2">เตรียมขาย</div>
								<div className="th col-lg-2">ราคาทุนเฉลี่ย (฿)</div>
								<div className="th col-lg-2"/>
							</div>
						</div>
						<div className="tbody">
							{
								this.state.products.length === 0
									? <div className="td span16" style={{textAlign: 'center'}}>ยังไม่มีข้อมูล</div>
									: null
							}
							{
								this.state.products.map((product, i) => {
									if (this.state.qs.product_ids) {
										let _product_ids = []
										let __product_ids = this.state.qs.product_ids.split(',')
										__product_ids.map((v) => {
											_product_ids.push(parseInt(v))
											return true
										})

										if (_product_ids.indexOf(product.id) === -1) {
											return null;
										}
									}

									return (
										<div key={i}
										     className={
											     "tr" + (
												     product.stock_alert
												     && (product.stock_alert.is_alert_minimum
													     || product.stock_alert.is_alert_maximum
												     ) ? " stock-alert " : ""
											     )}
										>
											<div className='td col-lg-4'>
												<div>
													<div className='flex row middle-xs thumb_img'>
														<a href={'/v2/products/' + product.product.id}>
															<img src={product.product.product_image_file_upload.url}
															     alt={product.product.name}
															/>
														</a>
														<div>
															<a href={'/v2/products/' + product.product.id}
															   className='link'>
																<b>{product.product.name}</b>
															</a>
															<br/><span style={{
															color: '#858585',
															fontSize: '0.8rem'
														}}>{product.product.code}</span>
															{
																product.stock_alert
																&& product.stock_alert.is_alert_minimum
																	?
																	<div>
																		<a data-tooltip='คลิกยกเลิกแจ้งเตือน'
																		   data-inverted=""
																		   href="/#"
																		   data-no_navigo=""
																		   data-stock_alert_id={product.stock_alert.stock_alert.id}
																		   style={{color: 'red'}}
																		   className="link"
																		   onClick={(e) => {
																			   e.preventDefault();
																			   this.voidStockAlert(
																				   product.stock_alert.stock_alert.id
																			   );
																		   }}
																		><b>
																			ปริมาณต่ำกว่า {window.GlobalFunc.getUnitNameByQuantity2({
																			product: product.product,
																			quantity: product.stock_alert.stock_alert.minimum,
																			ratio: product.stock_alert.stock_alert.minimum_ratio
																		})['text']}
																		</b>
																		</a>
																	</div>
																	: null
															}
															{
																product.stock_alert
																&& product.stock_alert.is_alert_maximum
																	?
																	<div>
																		<a data-tooltip='คลิกยกเลิกแจ้งเตือน'
																		   data-inverted=""
																		   href="/#"
																		   data-no_navigo=""
																		   data-stock_alert_id={product.stock_alert.stock_alert.id}
																		   style={{color: 'red'}}
																		   className="link"
																		   onClick={(e) => {
																			   e.preventDefault();
																			   this.voidStockAlert(
																				   product.stock_alert.stock_alert.id
																			   );
																		   }}
																		><b>
																			ปริมาณเกิน {window.GlobalFunc.getUnitNameByQuantity2({
																			product: product.product,
																			quantity: product.stock_alert.stock_alert.maximum,
																			ratio: product.stock_alert.stock_alert.maximum_ratio
																		})['text']}
																		</b>
																		</a>
																	</div>
																	: null
															}
															{
																product.stock_alert
																&& !product.stock_alert.is_alert_minimum
																&& !product.stock_alert.is_alert_maximum
																	?
																	<a style={{color: 'grey', cursor: 'pointer'}}
																	   className="link"
																	   href="/#"
																	   data-no_navigo=""
																	   onClick={(e) => {
																		   e.preventDefault();
																		   this.voidStockAlert(
																			   product.stock_alert.stock_alert.id
																		   );
																	   }}
																	>ยกเลิกแจ้งเตือน</a>
																	: null
															}

															<div className={'mt-1 flex flex-row wrap'}>
																<div className={'mr-2'}>
																	<Link className="ui icon green basic mini button"
																	      to={"/v2/shipments?has_product_ids=" + product.product.id + "&order_by=done_date_desc"}>
																		<i className="info icon"
																		   style={{height: 'initial'}}/> ดูประวัติล่าสุด
																	</Link>
																</div>
																<div>
																	<div className="ui icon green basic mini button"
																	     onClick={() => {
																		     window.Global.reactToDom(
																			     window.$('body'),
																			     <ShipmentProductAudit
																				     product={product.product}
																			     />
																		     );
																	     }}>
																		<i className="history icon"
																		   style={{height: 'initial'}}/> ตรวจสอบสินค้า
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
											<div className='td col-lg-2'>
												<div>
													<div>
														{
															window.GlobalFunc.getUnitNameByQuantity2({
																product: product.product,
																quantity: product.product_stock.on_hand,
																ratio: product.check_stock_display_ratio
															})['text']
														}
													</div>
													{
														product.stock_alert
														&& product.stock_alert.is_alert_minimum
															?
															<div>
																<div className='ui label red tiny'>
																	{"< "}{window.GlobalFunc.getUnitNameByQuantity2({
																	product: product.product,
																	quantity: product.stock_alert.stock_alert.minimum,
																	ratio: product.stock_alert.stock_alert.minimum_ratio
																})['text']}
																</div>
															</div> : null
													}
													{
														product.stock_alert
														&& product.stock_alert.is_alert_maximum
															?
															<div>
																<div className='ui label red tiny'>
																	{"> "}{window.GlobalFunc.getUnitNameByQuantity2({
																	product: product.product,
																	quantity: product.stock_alert.stock_alert.maximum,
																	ratio: product.stock_alert.stock_alert.maximum_ratio
																})['text']}
																</div>
															</div> : null
													}
												</div>
											</div>
											<div className='td col-lg-2'>
												{
													this.state.is_current
														?
														window.GlobalFunc.getUnitNameByQuantity2({
															product: product.product,
															quantity: product.product_stock.incoming,
															ratio: product.check_stock_display_ratio
														})['text']
														: '-'
												}
											</div>
											<div className='td col-lg-2'>
												{
													this.state.is_current
														?
														window.GlobalFunc.getUnitNameByQuantity2({
															product: product.product,
															quantity: product.product_stock.available,
															ratio: product.check_stock_display_ratio
														})['text']
														: '-'
												}
											</div>
											<div className='td col-lg-2'>
												{
													this.state.is_current
														?
														window.GlobalFunc.getUnitNameByQuantity2({
															product: product.product,
															quantity: product.product_stock.committed,
															ratio: product.check_stock_display_ratio
														})['text']
														: '-'
												}
											</div>
											<div className='td col-lg-2'>
												<div>
													{
														product.chart_product_cost.is_found
															?
															<>
																{product.chart_product_cost.price_average_exclude_vat.format(2)}
																&nbsp;&nbsp;<span
																style={{color: 'grey', fontSize: '0.9rem'}}
																data-tooltip={'คำนวนจากใบเสร็จซื้อและยอดยกมา (ทั้งหมด ' + window.GlobalFunc.getUnitNameByQuantity2({
																	product: product['product'],
																	quantity: product['chart_product_cost']['quantity'],
																	ratio: product['check_stock_display_ratio']
																})['text'] + ')'}
																data-inverted=''>
																<i className="icon info circle"/>
															</span>
															</>
															: '-'
													}
												</div>
											</div>
											<div className='td col-lg-2'>
												<div className='flex row between-xs'>
													<div className='hover-fade'>
														<button className='ui button'
														        type='button'
														        onClick={() => {
															        this.manageStockAlert(
																        product.product,
																        product.stock_alert
																	        ? product.stock_alert.stock_alert
																	        : false
															        );
														        }}>แจ้งเตือน
														</button>
														<button className='ui button'
														        type='button'
														        onClick={() => {
															        // CheckStock.manageDisplayRatio({
															        // 	stock: response['stock'],
															        // 	product: value['product']
															        // });
															        this.manageDisplayRatio(product);
														        }}>
															แสดงหน่วยนับอื่น
														</button>
													</div>
												</div>
											</div>
										</div>
									)
								})
							}
						</div>
					</div>
				</div>
			</div>
		)
	}

	render() {
		if (!this.state.mode || this.state.is_loading) {
			return <div className="ui active centered inline loader"/>
		}
		if (this.state.mode === 'list') {
			return this.renderList();
		}
		return null;
	}
}
